import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../kms.service';

@Component({
  selector: 'app-version-edit',
  templateUrl: './version-edit.component.html',
  styleUrls: ['./version-edit.component.css']
})
export class VersionEditComponent implements OnInit {
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  // 数据绑定对象
  model: any = {}; 
  // 提交按钮是否禁用
  clickEnable = true; 
  constructor(
    private box: SwMassageBoxService,  //消息提示框
    private kmsService: KmsService,   //请求服务
  ) { }

  ngOnInit() {
    this.clickLoca(this.param["selectedData"]);
  }
  
  clickLoca(selectedData: any) {
    // 查询模型信息
    this.kmsService.queryRecordInfoById(selectedData.id).subscribe(
      data => {
        if (data["code"] == '200') {
          this.model = data["data"];
          this.model['modelName'] = selectedData.modelName;
        }
      }
    )
  }

  // 保存新增的模型信息
  onSubmit({ value, valid }, event: Event) {
    if (valid) {
      this.clickEnable = false;
      this.kmsService.updateRecordInfo(this.model).subscribe(
        data => {
          this.clickEnable = true;
          if(data.code == '200'){
            this.box.success('保存成功！');
            this.modal.toggle();
            this.callback.emit(true);
          }else{
            this.box.waring(data.msg);
          }
        }
      )
    }
  }
}


